import React from 'react';
import ReactDOM from 'react-dom';
import {Link} from 'react-router'
import General from '../modules/General';

class NotFound extends React.Component {

	componentWillMount() {
		
		this.addBodyClass(true);
	}

	componentWillUnmount() {
		this.addBodyClass(false);
	}

	addBodyClass(add) {
		if(add) {
			document.body.classList.add('layout-full');
			document.body.classList.add('page-error-404');
			document.body.classList.add('page-error');
		}else{
			document.body.classList.remove('layout-full');
			document.body.classList.remove('page-error-404');
			document.body.classList.remove('page-error');
		}
	}

	render() {
		return (
			<div className="page vertical-align text-xs-center" data-animsition-in="fade-in" data-animsition-out="fade-out">
				<div className="page-content vertical-align-middle">
					<header>
						<h1 className="animation-slide-top">404</h1>
						<p>Page Not Found !</p>
					</header>
					<p className="error-advise">I'M LOST, HELP!</p>
					<Link to={General.Link('/dashboard')} className="btn btn-primary btn-round">GET ME BACK TO SAFETY</Link>
				</div>
			</div>
		);
	}
}

export default NotFound;


// WEBPACK FOOTER //
// ./containers/NotFound.js